// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./Testimonials.css";

// function Testimonials() {
//   const [testimonials, setTestimonials] = useState([]);
//   const [index, setIndex] = useState(0);
//   const [screenWidth, setScreenWidth] = useState(window.innerWidth);

//   useEffect(() => {
//     axios
//       .get("https://atlastravelhouse.com/api/testimonials/")
//       .then((res) => setTestimonials(res.data))
//       .catch((err) => console.log(err));
//   }, []);

//   useEffect(() => {
//     const handleResize = () => setScreenWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const total = testimonials.length;

//   const prevSlide = () => {
//     setIndex((prev) => (prev - 1 + total) % total);
//   };

//   const nextSlide = () => {
//     setIndex((prev) => (prev + 1) % total);
//   };
//   const getSlideStyle = (i) => {
//     if (total === 0) return {};
//     let offset = i - index;

//     if (offset > total / 2) offset -= total;
//     if (offset < -total / 2) offset += total;

//     const absOffset = Math.abs(offset);
//     let scale = 1;
//     let zIndex = 5 - absOffset;
//     let translateX = 0;
//     let opacity = 1;

//     let gap1 = screenWidth * 0.09; // nearest slide
//     let gap2 = screenWidth * 0.08; // second slide
//     let gap3 = screenWidth * 0.25; // farthest slide

//     if (absOffset === 0) {
//       scale = 1.2;
//       translateX = 0;
//       opacity = 1;
//     } else if (absOffset === 1) {
//       scale = 1;
//       translateX = offset * gap1;
//       opacity = 0.9;
//     } else if (absOffset === 2) {
//       scale = 0.9;
//       translateX = offset * gap2;
//       opacity = 0.8;
//     } else {
//       scale = 0.7;
//       translateX = offset * gap3;
//       opacity = 0.6;
//     }

//     return {
//       zIndex,
//       transform: `translateX(${translateX}px) scale(${scale})`,
//       opacity,
//       transition: "all 0.5s ease",
//     };
//   };

//   const StarRating = ({ rating }) => {
//     const totalStars = 5;
//     return (
//       <div className="stars">
//         {Array.from({ length: totalStars }, (_, i) => (
//           <span key={i} className={i < rating ? "star filled" : "star"}>
//             ★
//           </span>
//         ))}
//       </div>
//     );
//   };

//   /* .........*/
//   useEffect(() => {
//   let startX = 0;
//   let endX = 0;

//   const handleTouchStart = (e) => {
//     startX = e.touches[0].clientX;
//   };

//   const handleTouchMove = (e) => {
//     endX = e.touches[0].clientX;
//   };

//   const handleTouchEnd = () => {
//     const diff = startX - endX;
//     if (Math.abs(diff) > 50) { // Minimum swipe distance
//       if (diff > 0) {
//         nextSlide(); // swipe left → next
//       } else {
//         prevSlide(); // swipe right → previous
//       }
//     }
//   };

//   const slider = document.querySelector(".testimonial-slider");
//   if (slider) {
//     slider.addEventListener("touchstart", handleTouchStart);
//     slider.addEventListener("touchmove", handleTouchMove);
//     slider.addEventListener("touchend", handleTouchEnd);
//   }

//   return () => {
//     if (slider) {
//       slider.removeEventListener("touchstart", handleTouchStart);
//       slider.removeEventListener("touchmove", handleTouchMove);
//       slider.removeEventListener("touchend", handleTouchEnd);
//     }
//   };
// }, [nextSlide, prevSlide]);
 


//   return (
//     <div className="testimonial-section">
//       <h2 className="testimonial-heading">Customer Stories</h2>
//       <div className="testimonial-slider-container">
//         <div className="arrow left" onClick={prevSlide}>
//           &#10094;
//         </div>
//         <div className="testimonial-slider">
//           {testimonials.map((t, i) => (
//             <div
//               key={t.id}
//               className="testimonial-slide"
//               style={getSlideStyle(i)}
//             >
//               <img
//                 src={
//                   t.photo
//                     ? t.photo.startsWith("http")
//                       ? t.photo
//                       : `http://127.0.0.1:8000${t.photo}`
//                     : "/placeholder.png"
//                 }
//                 alt={t.name}
//                 className="testimonial-img"
//               />
//               <h4 className="namehead">{t.name}</h4>
//               <p className="company">{t.company}</p>
//               <div className="comment-container">
//                 <p className="comment">{t.comment}</p>
//               </div>
//               <StarRating rating={t.rating} />
//             </div>
//           ))}
//         </div>
//         <div className="arrow right" onClick={nextSlide}>
//           &#10095;
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Testimonials;




// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import "./Testimonials.css";

// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

// function Testimonials() {
//   const [testimonials, setTestimonials] = useState([]);

//   useEffect(() => {
//     axios
//       .get("https://atlastravelhouse.com/api/testimonials/")
//       .then((res) => setTestimonials(res.data))
//       .catch((err) => console.log(err));
//   }, []);

//   const StarRating = ({ rating }) => {
//     return (
//       <div className="stars">
//         {Array.from({ length: 5 }, (_, i) => (
//           <span key={i} className={i < rating ? "star filled" : "star"}>
//             ★
//           </span>
//         ))}
//       </div>
//     );
//   };

//   return (
//     <div className="testimonial-section">
//       <h2 className="testimonial-heading">Testimonials</h2>
// {/* <Swiper
//   modules={[Autoplay, Navigation]} 
//   navigation={true}
//   loop={true}
//   slidesPerView={"auto"}
//   spaceBetween={20}
//   speed={400}
//   autoHeight={false} 
//   autoplay={{
//     delay: 5000,
//     disableOnInteraction: false,
//     pauseOnMouseEnter: true,
//   }}
//   allowTouchMove={true}
//   className="testimonial-swiper"
// > */}
// {testimonials.length > 0 && (
//   <Swiper
//     key={testimonials.length}
//     modules={[Autoplay, Navigation]}
//     navigation={true}
//     loop={true}
//     slidesPerView={1}
//     spaceBetween={20}
//     speed={400}
//     autoplay={{
//       delay: 4000,
//       disableOnInteraction: false,
//     }}
//     className="testimonial-swiper"
//   >
//         {testimonials.map((t) => (
//           <SwiperSlide key={t.id}>
//             <div className="testimonial-card">
              
//               <div className="left">
//                 <img
//                   src={
//                     t.photo
//                       ? t.photo.startsWith("http")
//                         ? t.photo
//                         : `http://127.0.0.1:8000${t.photo}`
//                       : "/placeholder.png"
//                   }
//                   alt={t.name}
//                 />
//               </div>

//               <div className="right">
//                 <StarRating rating={t.rating} />

//                 <p className="comment">{t.comment}</p>

//                 <div className="user-info">
//                   <h4>{t.name}</h4>
//                   <p>{t.company}</p>
//                 </div>
//               </div>

//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>)}
//     </div> 
//   );
// }

// export default Testimonials;




import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Testimonials.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

function Testimonials({ category }) {
  const [testimonials, setTestimonials] = useState([]);

useEffect(() => {

  const url = category
    ? `https://atlastravelhouse.com/api/testimonials/?category=${category}`
    : `https://atlastravelhouse.com/api/testimonials/`;

  axios
    .get(url)
    .then((res) => {
      setTestimonials(res.data);
    })
    .catch((err) => console.log(err));

}, [category]);

  const StarRating = ({ rating }) => {
    return (
      <div className="stars">
        {Array.from({ length: 5 }, (_, i) => (
          <span key={i} className={i < rating ? "star filled" : "star"}>
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="testimonial-section">
      {/* <h2 className="testimonial-heading">Testimonials</h2> */}
<h2
  className={`testimonial-heading ${
    category === "events"
      ? "testimonial-heading-dark"
      : category === "travel"
      ? "testimonial-heading-light"
      : "testimonial-heading-default"
  }`}
>
  Stories From Our Clients
</h2>
      <Swiper
        modules={[Autoplay, Navigation]}
        navigation={true}
        loop={true}
        slidesPerView={"auto"}
        spaceBetween={20}
        speed={400}
        autoHeight={false}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        allowTouchMove={true}
        className="testimonial-swiper"
      >
        {testimonials.map((t) => (
          <SwiperSlide key={t.id}>
            <div className="testimonial-card">

              <div className="left">
                <img
                  src={
                    t.photo
                      ? t.photo.startsWith("http")
                        ? t.photo
                        : `http://127.0.0.1:8000${t.photo}`
                      : "/placeholder.png"
                  }
                  alt={t.name}
                />
              </div>
<div
  className={`right ${
    category === "events"
      ? "testimonial-right-dark"
      : category === "travel"
      ? "testimonial-right-light"
      : "testimonial-right-default"
  }`}
>
  <StarRating rating={t.rating} />

  <p className="comment">{t.comment}</p>

  <div className="user-info">
    <h4>{t.name}</h4>
    <p>{t.company}</p>
  </div>
</div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export default Testimonials;